import React from "react";

import useCommentFilterContext from "./useCommentFilterContext";

export function withCommentFilterContext(WrappedComponent) {
  return (props) => {
    const filterContext = useCommentFilterContext();

    return <WrappedComponent {...props} filterContext={filterContext} />;
  };
}

export default withCommentFilterContext;
